<template lang="pug">
.home-features(
  @mouseover="mouseoverHandler"
  @mouseout="mouseoutHandler"
)
  router-link.members-feature.feature(:to="{ name: 'membership' }")
    p.is-size-4 Become a Member
  router-link.believe-feature.feature(
    :class="{ 'is-selected': !active }"
    :to="{ name: 'believe' }"
  )
    p.is-size-4 What We Believe
  router-link.projects-feature.feature(:to="{ name: 'projects' }")
    p.is-size-4 Special Projects
</template>

<script>
export default {
  name: 'home-features',
  data() {
    return {
      active: false,
    };
  },
  methods: {
    mouseoverHandler() {
      this.active = true;
    },
    mouseoutHandler() {
      this.active = false;
    },
  },
};
</script>

<style lang="scss">
.home-features {
  width: 100%;
  display: flex;
  align-items: center;
  .feature {
    display: flex;
    flex-grow: 1;
    align-items: center;
    justify-content: center;
    width: 30vw;
    height: calc(30vw * 9/16);
    color: $white;
    background-size: cover;
    background-color: $black;
    position: relative;
    z-index: 1;
    font-weight: 700;
    &.believe-feature {
      background-image: url('/images/cwo/believe03.jpg');
    }
    &.members-feature {
      background-image: url('/images/cwo/members01.jpg');
    }
    &.projects-feature {
      background-image: url('/images/cwo/project01.jpg');
    }
  }
  @media (min-width: $tablet) {
    .feature {
      border-radius: 4px;
      opacity: 0.35;
      filter: grayscale(100%);
      transform: scale3d(1.0);
      transition: 0.25s opacity ease-in-out, 0.25s filter ease-in-out, 0.25s transform ease-in-out;
      &:hover, &.is-selected {
        opacity: 1.0;
        filter: grayscale(0%);
        box-shadow: 0 0 60px rgba(0,0,0,0.2);
        transform: scale3d(1.25, 1.25, 1.25);
        z-index: 2;
      }
      &:first-child {
        transform-origin: center left;
      }
      &:last-child {
        transform-origin: center right;
      }
    }
  }
  @media (max-width: $tablet) {
    flex-flow: column;
    .feature {
      width: 100%;
      height: calc(100vw * 9/16);
      & + .feature {
        margin-top: 1.75rem;
      }
    }
  }
}
</style>
